var map = {
	"./apple-pay-white.svg": "xBvI",
	"./applepay.svg": "UJJg",
	"./blik.svg": "oZ7I",
	"./ideal-white.svg": "Zpyj",
	"./ideal.svg": "fMUV",
	"./kammerkollegiet.svg": "4wso",
	"./klarna.svg": "G5hQ",
	"./mastercard.svg": "3PWj",
	"./mastercard_logo.svg": "ORlD",
	"./mobilepay.svg": "Qegh",
	"./nets.svg": "ILk0",
	"./onlineBankingPL.svg": "yzsW",
	"./paypalLogo.svg": "3D3V",
	"./paypo.svg": "ZHmt",
	"./trustly-white.svg": "Px+M",
	"./trustly.png": "59Do",
	"./visa.svg": "Bamm",
	"./visa_logo.svg": "sv8j"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nSRr";